<div class="dialog-container">
  <form [formGroup]="deleteKey">
    @if (screenWidth <= 480) {
      <div class="close-icon">
        <div class="close add-close-button" data-dismiss="modal" (click)="closeDialog()">
          <span class="material-icons close-icon-web">clear</span>
        </div>
      </div>
    }

    <div class="web-close-icon">
      <button
        matTooltipPosition="above"
        data-dismiss="modal" (click)="closeDialog()" class="web-close-btn">
        <span class="material-icons " style="position: relative;">clear</span>
      </button>
    </div>


    <div class="delete-key-wrapper">
      <div class="delete-img-container">
        <img src="../../../../../../../assets/images/security-key-green.svg" class="delete-key-img"/>
      </div>

      <div class="delete-text-container">
        <h2 class="delete-text-main">Security Verification</h2>
        <h2 class="delete-sub-text">Please enter the security key in order to proceed.</h2>

        <p class="delete-warning-text">
          <span class="delete-warning">Warning: </span>Deleting this key is permanent. All files that you have protected with this key will no longer be protected with a security key. Would you like to proceed?
        </p>
      </div>

      <div class="input-key">
            <mat-form-field appearance="fill" class="security-key-textarea-delete" [ngClass]="((deleteKey.controls['securityKey'].dirty &&
                                                                                                deleteKey.controls['securityKey'].touched &&
                                                                                                deleteKey.controls['securityKey'].invalid) || isError
                                                                                                ) ? 'automtic-form-desing-error': ''">
          <mat-label class="automtic-form-desing-lable label-for-notes">Key
            <span class="automtic-form-desing-required-sign"> * </span>

            <span class="hint-span">{{ deleteKey.controls['securityKey'].value.length }} / 245</span>
          </mat-label>

          <textarea matInput
            #message
            maxlength="245"
            placeholder="Enter Key"
            formControlName="securityKey"
            (ngModelChange)="onPercentChangeKey($event)"
            >
          </textarea>
          @if (isError) {
            <mat-hint class="input-error-message" style="height: auto;">The entered key is not correct</mat-hint>
          }
        </mat-form-field>

      </div>

      @if (screenWidth > 480) {
        <div class="deletekey-action">
          <button type="button" class="deletekey-btn" (click)="verifyAndDelete()" [class.disable-button-continue]="( deleteKey.controls['securityKey'].value.length ==0 || !deleteKey.controls['securityKey'].valid) || isError">Delete Key</button>
        </div>
      }

      @if (screenWidth <= 480) {
        <div class="deletekey-action modal-footer">
          <button type="button" class="deletekey-btn" (click)="verifyAndDelete()" [class.disable-button-continue]="(deleteKey.controls['securityKey'].value.length ==0 || !deleteKey.controls['securityKey'].valid) || isError">Delete Key</button>
        </div>
      }
    </div>
  </form>
</div>